import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { DeliveriesByCourseResponse } from 'src/entities/Report.entity';

const requestPath = '/api/v5/reports/deliveries_by_course';
const queryPrefix = 'useDeliveriesByCourseQuery';

type Params = {
  startOn: string;
  endOn: string;
  shipperNames: string[];
};

const fetchDeliveriesByCourse = ({ startOn, endOn, shipperNames }: Params) => async () => {
  const response = await axios.get<DeliveriesByCourseResponse>(requestPath, {
    params: { start_on: startOn, end_on: endOn, shipper_names: shipperNames },
  });
  return response.data;
};

export const useDeliveriesByCourseQuery = ({ startOn, endOn, shipperNames }: Params) => useQuery(
  [queryPrefix, { startOn, endOn, shipperNames }],
  fetchDeliveriesByCourse({ startOn, endOn, shipperNames }),
  {
    staleTime: Infinity,
    enabled: Boolean(startOn) && Boolean(endOn) && shipperNames.length > 0,
  },
);
